<template>
  <q-chip
    class="status-chip"
    :class="{ 'cursor-pointer': clickable }"
    :color="color"
    :small="small"
    :icon-right="clickable ? 'expand_more' : null"
    @click="handleClick"
  >
    <div class="row items-center no-wrap">
      <div>
        <q-icon v-if="committed" name="lock" size="1rem"/>

        <q-tooltip>
          {{ $t('quote_committed') }}
        </q-tooltip>
      </div>

      <span :class="{ 'on-right': committed }" @click="handleClick">{{ $t(status) }}</span>
    </div>

    <q-popover ref="popover" :disable="!clickable">
      <q-list item-separator link v-if="!showNoAction">
        <template v-if="showMarkAsAccepted">
          <!-- Mark as Accepted -->
          <q-item v-close-overlay @click.native="$emit('accepted')">
            <q-item-main>
              <span>{{ $t('mark_accepted') }}</span>
            </q-item-main>
          </q-item>
        </template>

        <template v-if="showMarkAsOpen">
          <!-- Mark as Open -->
          <q-item v-close-overlay @click.native="$emit('open')">
            <q-item-main>
              <span>{{ $t('mark_open') }}</span>
            </q-item-main>
          </q-item>
        </template>

        <q-item-separator/>

        <template v-if="showMarkAsCanceled">
          <!-- Cancel Quote -->
          <q-item v-close-overlay @click.native="$emit('cancel')">
            <q-item-main>
              <span>{{ $t('cancel_quote') }}</span>
            </q-item-main>
          </q-item>
        </template>
      </q-list>

      <template v-if="showNoAction">
        <div class="q-px-lg q-py-md">
          <span class="text-faded">{{ $t('no_action_available') }}</span>
        </div>
      </template>
    </q-popover>
  </q-chip>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        required: true
      },

      committed: {
        type: Boolean,
        default: false
      },

      color: {
        type: String
      },

      small: {
        type: Boolean,
        default: false
      },

      clickable: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      showMarkAsOpen () {
        return ['accepted', 'canceled', 'expired'].includes(this.status)
      },

      showMarkAsAccepted () {
        return ['canceled', 'open', 'expired'].includes(this.status)
      },

      showMarkAsCanceled () {
        return ['accepted', 'open', 'expired'].includes(this.status)
      },

      showNoAction () {
        return ['draft'].includes(this.status)
      }
    },

    methods: {
      handleClick () {
        this.$refs.popover.toggle()
      }
    }
  }
</script>
